import { BehaviorSubject, Observable } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class MessageService {
  public attritionTrendSubject: BehaviorSubject<any> = new BehaviorSubject({});
  public kRRTrendData: BehaviorSubject<any> = new BehaviorSubject({});
  public resourceTrendData: BehaviorSubject<any> = new BehaviorSubject({});
  public spendTrendData: BehaviorSubject<any> = new BehaviorSubject({});
  public staffingPhyramidData: BehaviorSubject<any> = new BehaviorSubject({});
  public applicationSelected: BehaviorSubject<any> = new BehaviorSubject({});
  public changeRequestData: BehaviorSubject<any> = new BehaviorSubject({});
  public subscribeOKRData: BehaviorSubject<any> = new BehaviorSubject({});
  public subscribeTagsData: BehaviorSubject<any> = new BehaviorSubject({});
  public subscribeOnwerData: BehaviorSubject<any> = new BehaviorSubject({});
  public subscribeWorkgroupData: BehaviorSubject<any> = new BehaviorSubject({});
  public subscribeLinkedPIData: BehaviorSubject<any> = new BehaviorSubject({});
  public subscribeCaptureData: BehaviorSubject<any> = new BehaviorSubject({});
  public subscribeParadeImageData: BehaviorSubject<any> = new BehaviorSubject(
    {}
  );
  public iframeData: BehaviorSubject<any> = new BehaviorSubject({});
  public newsData: BehaviorSubject<any> = new BehaviorSubject({});
  public updatedDeliveryObligation: BehaviorSubject<any> = new BehaviorSubject(
    {}
  );
  public hubbleInsightsVendors: BehaviorSubject<any> = new BehaviorSubject({});
  public surveyMode = new BehaviorSubject<boolean>(false);

  public surveyModeSubject = new BehaviorSubject<boolean>(false);
  surveyMode$ = this.surveyModeSubject.asObservable();

  setSurveyMode(isSurvey: boolean) {
    this.surveyModeSubject.next(isSurvey);
  }

  getSurveyMode(): boolean {
    return this.surveyModeSubject.getValue();
  }

  public piModeSubject = new BehaviorSubject<boolean>(false);
  piMode$ = this.piModeSubject.asObservable();

  setPiMode(isPi: boolean) {
    this.piModeSubject.next(isPi);
  }

  getPiMode(): boolean {
    return this.piModeSubject.getValue();
  }

  public ideaModeSubject = new BehaviorSubject<boolean>(false);
  ideaMode$ = this.ideaModeSubject.asObservable();

  setIdeaMode(isPi: boolean) {
    this.ideaModeSubject.next(isPi);
  }

  getIdeaMode(): boolean {
    return this.ideaModeSubject.getValue();
  }

  public OppWBModeSubject = new BehaviorSubject<number>(0);
  OppWBMode$ = this.OppWBModeSubject.asObservable();

  setOppWBMode(mode: number) {
    this.OppWBModeSubject.next(mode);
  }

  getOppWBMode(): number {
    return this.OppWBModeSubject.getValue();
  }

  public mastersModeSubject = new BehaviorSubject<boolean>(false);
  mastersMode$ = this.mastersModeSubject.asObservable();

  setMastersMode(isMasters: boolean) {
    this.mastersModeSubject.next(isMasters);
  }

  getMastersMode(): boolean {
    return this.mastersModeSubject.getValue();
  }


  public allocationSource = new BehaviorSubject<any>({
    isActive: false,
    chartOptions: {},
  });

  allocation$ = this.allocationSource.asObservable();

  setAllocationState(state: any) {
    this.allocationSource.next(state);
  }

  public surveyAiroInsights = new BehaviorSubject<{
    surveyName: string;
    totalSurveyResponse: any[];
  } | null>(null);

  setSurvey(surveyMode: any) {
    this.surveyMode.next(surveyMode);
  }

  getSurvey(): Observable<any> {
    return this.surveyMode.asObservable();
  }

  setAttritionTrendData(attritionTrendData: any) {
    this.attritionTrendSubject.next(attritionTrendData);
  }

  getAttritionTrendData(): Observable<any> {
    return this.attritionTrendSubject.asObservable();
  }

  setKRRTrendData(kRRTrendData: any) {
    this.kRRTrendData.next(kRRTrendData);
  }

  getKRRTrendData(): Observable<any> {
    return this.kRRTrendData.asObservable();
  }

  setResourceTrendData(resourceTrendData: any) {
    this.resourceTrendData.next(resourceTrendData);
  }

  getResourceTrendData(): Observable<any> {
    return this.resourceTrendData.asObservable();
  }

  setSpendTrendData(spendTrendData: any) {
    this.spendTrendData.next(spendTrendData);
  }

  getSpendTrendData(): Observable<any> {
    return this.spendTrendData.asObservable();
  }

  setStaffingPhyramidData(staffingPhyramidData: any) {
    this.staffingPhyramidData.next(staffingPhyramidData);
  }

  getStaffingPhyramidData(): Observable<any> {
    return this.staffingPhyramidData.asObservable();
  }

  setApplicationSelected(applicationSelected: any) {
    this.applicationSelected.next(applicationSelected);
  }

  getApplicationSelected(): Observable<any> {
    return this.applicationSelected.asObservable();
  }

  setChangeRequestData(changeRequestData: any) {
    this.changeRequestData.next(changeRequestData);
  }

  getChangeRequestData(): Observable<any> {
    return this.changeRequestData.asObservable();
  }

  setSubscribeOKRData(subscribeOKRData: any) {
    this.subscribeOKRData.next(subscribeOKRData);
  }

  getSubscribeOKRData(): Observable<any> {
    return this.subscribeOKRData.asObservable();
  }

  setTags(subscribeTagsData: any) {
    this.subscribeTagsData.next(subscribeTagsData);
  }

  getTags(): Observable<any> {
    return this.subscribeTagsData.asObservable();
  }

  setOwner(subscribeOnwerData: any) {
    this.subscribeOnwerData.next(subscribeOnwerData);
  }

  getOwner(): Observable<any> {
    return this.subscribeOnwerData.asObservable();
  }

  setWorkgroup(subscribeWorkgroupData: any) {
    this.subscribeWorkgroupData.next(subscribeWorkgroupData);
  }

  getWorkgroup(): Observable<any> {
    return this.subscribeWorkgroupData.asObservable();
  }

  setLinkedPIData(subscribeLinkedPIData: any) {
    this.subscribeLinkedPIData.next(subscribeLinkedPIData);
  }

  getLinkedPIData(): Observable<any> {
    return this.subscribeLinkedPIData.asObservable();
  }

  setCaptureStatus(subscribeCaptureData: any) {
    this.subscribeCaptureData.next(subscribeCaptureData);
  }

  getCaptureStatus(): Observable<any> {
    return this.subscribeCaptureData.asObservable();
  }

  setParadeImage(subscribeParadeImageData: any) {
    this.subscribeParadeImageData.next(subscribeParadeImageData);
  }

  getParadeImage(): Observable<any> {
    return this.subscribeParadeImageData.asObservable();
  }

  setIframeData(iframeData: any) {
    this.iframeData.next(iframeData);
  }

  getIframeData(): Observable<any> {
    return this.iframeData.asObservable();
  }

  setGnews(newsData: any) {
    this.newsData.next(newsData);
  }

  getGnews(): Observable<any> {
    return this.newsData.asObservable();
  }

  setUpdatedDeliveryObligation(updatedDeliveryObligation: any) {
    this.updatedDeliveryObligation.next(updatedDeliveryObligation);
  }

  getUpdatedDeliveryObligation(): Observable<any> {
    return this.updatedDeliveryObligation.asObservable();
  }

  setHubbleInsightVendor(vendors: Array<any>) {
    this.hubbleInsightsVendors.next(vendors);
  }

  getHubbleInsightVendor() {
    return this.hubbleInsightsVendors.asObservable();
  }

  setsurveyAiroInsights(surveyName: string, totalSurveyResponse: any[]) {
    this.surveyAiroInsights.next({ surveyName, totalSurveyResponse });
  }

  getsurveyAiroInsights() {
    return this.surveyAiroInsights.asObservable();
  }
}
